import React, { Component } from 'react';
import SideBar from '../SideBar/SideBar';
import './TicketBooking.css'
import { toast } from 'react-toastify';
import Loader from '../Components/Utils/AnLoader/Loader'
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import axios from "../Constant/axios"

export default class TicketBooking extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            ticketBookDetails: [],
            serialNo: 1,
            invoiceDetails: [],
            CityMasterData: [],
            AirlineMasterData: [],
            PartyMasterData: [],
            inputValues: {
                srno: 1,
                bill_to: "",
                booked_by: "",
                party_gst_no: "",
                place_of_supply: "",
                gmail_id: "",
                invoice_no: "",
                invoice_date: new Date().toLocaleDateString('en-CA'),
                sac_code: "",
                date_of_travel: "",
                ticket_no: "",
                passenger_name: "",
                sector: "",
                class: "",
                flt_no: "",
                ticket_amount: "",
                taxable_value: "",
                igst: "",
                total_amount_with_tax: "",
                cr_by: "",
                dep: "",
                arr: "",
                from_short_city_name: "",
                to_short_city_name: "",
                airline_names: "",
                seat_no: "",
                air_fare: "",
                taxes_and_fees: "",
                
            },
        };
        this.handlePartyChange = this.handlePartyChange.bind(this);
    }

    componentDidMount() {
        // var login = localStorage.getItem("token")
        // if (login === null || login === undefined) window.location.href = "/";
        this.getInvoiceNo()
        this.getCityDetail()
        this.getAirlineDetail();
        this.getPartyDetail();

    }


    componentWillUnmount() {

    }
    getAirlineDetail = () => {
        debugger
        axios.get(`/getAirlineDetail`).then((res) => {
            if (res && res.data && res.data.data) {
                res.data.data.forEach(e => {
                    e.isDisabled = true
                });
                this.setState({ AirlineMasterData: res.data.data, loading: false, });
            } else {
                this.setState({ AirlineMasterData: [], loading: false, });
            }
        },
            (err) => {
                console.log(err);
            }
        );
    }
    handleChange = (selectedOption) => {
        this.setState({ selectedOption }, () =>
            console.log(`Option selected:`, this.state.selectedOption)
        );
    };
    getCityDetail = () => {
        debugger
        axios.get(`/getCityDetail`).then((res) => {
            if (res && res.data && res.data.data) {
                res.data.data.forEach(e => {
                    e.isDisabled = true;
                });
                this.setState({ CityMasterData: res.data.data, loading: false, });
            } else {
                this.setState({ CityMasterData: [], loading: false, });
            }
        },
            (err) => {
                console.log(err);
            }
        );
    }
    getInvoiceNo = () => {
        axios.get(`/invoiceNumber`).then((res) => {
            if (res && res.data && res.data.data.invoice_no) {
                this.state.inputValues.invoice_no = res.data.data.invoice_no
                this.setState({ inputValues: this.state.inputValues });
            } else {
                this.setState({ invoiceDetails: [], loading: false, });
            }
        },
            (err) => {
                console.log(err);
            }
        );
    }

    getPartyDetail = () => {
        axios.get(`/getPartyDetail`).then((res) => {
            if (res && res.data && res.data.data) {
                res.data.data.forEach(e => {
                    e.isDisabled = true
                });
                this.setState({ PartyMasterData: res.data.data, loading: false, });
            } else {
                this.setState({ PartyMasterData: [], loading: false, });
            }
        },
            (err) => {
                console.log(err);
            }
        );
    }
    handleCityChange = (event, name1, name2) => {
        debugger
        const { name, value } = event.target;

        var cityNameCity = this.state.CityMasterData.filter((item) => {
            return item.id == value
        });

        this.setState(prevState => ({
            inputValues: {
                ...prevState.inputValues,
                [name1]: cityNameCity[0].city_code,
                [name2]: cityNameCity[0].city_name,
                [name]: value,
            }
        }));

    };
    handleInputChange = (e) => {
        debugger
        const { name, value } = e.target;

        if (name === "air_fare" && value !== "" ) {
            this.setState(prevState => ({
                inputValues: {
                    ...prevState.inputValues,
                    cal_total_air_fare: Math.round(parseFloat(value) + parseFloat(this.state.inputValues.taxes_and_fees))
                }
            }));
        }

        if (name === "taxes_and_fees" && value !== "" ) {
            this.setState(prevState => ({
                inputValues: {
                    ...prevState.inputValues,
                    cal_total_air_fare: Math.round(parseFloat(value) + parseFloat(this.state.inputValues.air_fare))
                }
            }));
        }

        if (name === "ticket_amount" && value !== "" && this.state.inputValues.taxable_value != "") {
            this.setState(prevState => ({
                inputValues: {
                    ...prevState.inputValues,
                    sgst: (parseFloat(this.state.inputValues.taxable_value) * (9 / 100)).toFixed(2),
                    cgst: (parseFloat(this.state.inputValues.taxable_value) * (9 / 100)).toFixed(2),
                    igst: (parseFloat(this.state.inputValues.taxable_value) * (18 / 100)).toFixed(2),
                    total_amount_with_tax: Math.round(parseFloat(value) + parseFloat((this.state.inputValues.taxable_value * (18 / 100))))
                }
            }));
        }
        if (name === "taxable_value") {
            this.setState(prevState => ({
                inputValues: {
                    ...prevState.inputValues,
                    sgst: (value * (9 / 100)).toFixed(2),
                    cgst: (value * (9 / 100)).toFixed(2),
                    igst: (value * (18 / 100)).toFixed(2),
                    total_amount_with_tax: Math.round(parseFloat(this.state.inputValues.ticket_amount) + parseFloat((value * (18 / 100))))
                }
            }));
        }
        this.setState(prevState => ({
            inputValues: {
                ...prevState.inputValues,
                [name]: value
            }
        }));
    }

    // Define handlePartyChange function
    handlePartyChange(event) {
        debugger
        const selectedPartyId = event.target.value;
        const selectedParty = this.state.PartyMasterData.find(party => party.party_id == selectedPartyId);
        const selectedPartyName = this.state.PartyMasterData.filter(party => party.party_id == selectedPartyId);

        // Update the state with the selected party's GST number
        this.setState({
            inputValues: {
                ...this.state.inputValues,
                party_id: selectedPartyId,
                bill_to: selectedPartyName[0].party_name,
                party_gst_no: selectedParty ? selectedParty.party_GST_no : ''
            }
        });
    }



    HandleAddNewRow = () => {
        debugger
        if (this.state.inputValues.bill_to === "" || this.state.inputValues.booked_by === "" || this.state.inputValues.party_gst_no === "" || this.state.inputValues.place_of_supply === ""
            || this.state.inputValues.gmail_id === "" || this.state.inputValues.sac_code === ""
            || this.state.inputValues.date_of_travel === "" || this.state.inputValues.ticket_no === ""
            || this.state.inputValues.passenger_name === "" || this.state.inputValues.sector === "" || this.state.inputValues.class === "" || this.state.inputValues.flt_no === ""
            || this.state.inputValues.ticket_amount === "" || this.state.inputValues.taxable_value === "" || this.state.inputValues.total_amount_with_tax === ""
            || this.state.inputValues.dep === "" || this.state.inputValues.arr === "" || this.state.inputValues.from_short_city_name === ""
            || this.state.inputValues.to_short_city_name === "" || this.state.inputValues.airline_names === "" || this.state.inputValues.seat_no === "" 
            || this.state.inputValues.air_fare === "" || this.state.inputValues.taxes_and_fees === "" ) {
            toast.error("Please fill in all input fields before creating a new ticket.")

            if (this.state.inputValues.bill_to === "") document.querySelector("#bill_to").style.border = "1px solid red";
            if (this.state.inputValues.booked_by === "") document.querySelector("#booked_by").style.border = "1px solid red";
            if (this.state.inputValues.place_of_supply === "") document.querySelector("#place_of_supply").style.border = "1px solid red";
            if (this.state.inputValues.gmail_id === "") document.querySelector("#gmail_id").style.border = "1px solid red";
            if (this.state.inputValues.sac_code === "") document.querySelector("#sac_code").style.border = "1px solid red";
            if (this.state.inputValues.date_of_travel === "") document.querySelector("#date_of_travel").style.border = "1px solid red";
            if (this.state.inputValues.passenger_name === "") document.querySelector("#passenger_name").style.border = "1px solid red";
            if (this.state.inputValues.ticket_no === "") document.querySelector("#ticket_no").style.border = "1px solid red";
            if (this.state.inputValues.passenger_name === "") document.querySelector("#passenger_name").style.border = "1px solid red";
            if (this.state.inputValues.sector === "") document.querySelector("#sector").style.border = "1px solid red";
            if (this.state.inputValues.class === "") document.querySelector("#class").style.border = "1px solid red";
            if (this.state.inputValues.flt_no === "") document.querySelector("#flt_no").style.border = "1px solid red";
            if (this.state.inputValues.ticket_amount === "") document.querySelector("#ticket_amount").style.border = "1px solid red";
            if (this.state.inputValues.taxable_value === "") document.querySelector("#taxable_value").style.border = "1px solid red";
            if (this.state.inputValues.dep === "") document.querySelector("#dep").style.border = "1px solid red";
            if (this.state.inputValues.arr === "") document.querySelector("#arr").style.border = "1px solid red";
            if (this.state.inputValues.from_short_city_name === "") document.querySelector("#from_short_city_name").style.border = "1px solid red";
            if (this.state.inputValues.seat_no === "") document.querySelector("#seat_no").style.border = "1px solid red";
            if (this.state.inputValues.to_short_city_name === "") document.querySelector("#to_short_city_name").style.border = "1px solid red";
            if (this.state.inputValues.airline_names === "") document.querySelector("#airline_names").style.border = "1px solid red";
            if (this.state.inputValues.air_fare === "") document.querySelector("#air_fare").style.border = "1px solid red";
            if (this.state.inputValues.taxes_and_fees === "") document.querySelector("#taxes_and_fees").style.border = "1px solid red";

            if (this.state.inputValues.bill_to !== "") document.querySelector("#bill_to").style.border = "";
            if (this.state.inputValues.booked_by !== "") document.querySelector("#booked_by").style.border = "";
            if (this.state.inputValues.place_of_supply !== "") document.querySelector("#place_of_supply").style.border = "";
            if (this.state.inputValues.gmail_id !== "") document.querySelector("#gmail_id").style.border = "";
            if (this.state.inputValues.sac_code !== "") document.querySelector("#sac_code").style.border = "";
            if (this.state.inputValues.date_of_travel !== "") document.querySelector("#date_of_travel").style.border = "";
            if (this.state.inputValues.passenger_name !== "") document.querySelector("#passenger_name").style.border = "";
            if (this.state.inputValues.ticket_no !== "") document.querySelector("#ticket_no").style.border = "";
            if (this.state.inputValues.passenger_name !== "") document.querySelector("#passenger_name").style.border = "";
            if (this.state.inputValues.sector !== "") document.querySelector("#sector").style.border = "";
            if (this.state.inputValues.class !== "") document.querySelector("#class").style.border = "";
            if (this.state.inputValues.flt_no !== "") document.querySelector("#flt_no").style.border = "";
            if (this.state.inputValues.ticket_amount !== "") document.querySelector("#ticket_amount").style.border = "";
            if (this.state.inputValues.taxable_value !== "") document.querySelector("#taxable_value").style.border = "";
            if (this.state.inputValues.dep !== "") document.querySelector("#dep").style.border = "";
            if (this.state.inputValues.arr !== "") document.querySelector("#arr").style.border = "";
            if (this.state.inputValues.from_short_city_name !== "") document.querySelector("#from_short_city_name").style.border = "";
            if (this.state.inputValues.seat_no !== "") document.querySelector("#seat_no").style.border = "";
            if (this.state.inputValues.to_short_city_name !== "") document.querySelector("#to_short_city_name").style.border = "";
            if (this.state.inputValues.airline_names !== "") document.querySelector("#airline_names").style.border = "";
            if (this.state.inputValues.air_fare !== "") document.querySelector("#air_fare").style.border = "";
            if (this.state.inputValues.taxes_and_fees !== "") document.querySelector("#taxes_and_fees").style.border = "";
            return false;
        }

        if (this.state.inputValues.gmail_id !== "") {
            var inputvalues = this.state.inputValues.gmail_id
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if (!regex.test(inputvalues)) {
                toast.error('Invalid Email ID Enter!')
                return false;
            }
        }
        Swal.fire({
            title: "Please save the previous ticket data and create a new ticket.",
            input: "checkbox",
            inputValue: 1,
            inputPlaceholder: ` Same as Previous Ticket Details in New Ticket`,
            confirmButtonText: ` Continue&nbsp;<i class="fa fa-arrow-right"></i> `,
            showCancelButton: true,
            confirmButtonColor: '#055032',
            cancelButtonText: 'No',
            inputValidator: (result) => {
                if (this.state.inputValues.isUpdated === undefined) {
                    this.state.ticketBookDetails.push(this.state.inputValues)
                }
                else {
                    let updatedSrno = 1;
                    this.state.ticketBookDetails.forEach(item => {
                        if (item.isUpdated && item.srno == this.state.inputValues.srno) {
                            item.srno = this.state.inputValues.srno;
                            item.bill_to = this.state.inputValues.bill_to;
                            item.booked_by = this.state.inputValues.booked_by;
                            item.invoice_no = this.state.inputValues.invoice_no;
                            item.invoice_date = this.state.inputValues.invoice_date;
                            item.party_gst_no = this.state.inputValues.party_gst_no;
                            item.place_of_supply = this.state.inputValues.place_of_supply;
                            item.gmail_id = this.state.inputValues.gmail_id;
                            item.sac_code = this.state.inputValues.sac_code;
                            item.date_of_travel = this.state.inputValues.date_of_travel;
                            item.ticket_no = this.state.inputValues.ticket_no;
                            item.passenger_name = this.state.inputValues.passenger_name;
                            item.sector = this.state.inputValues.sector;
                            item.class = this.state.inputValues.class;
                            item.flt_no = this.state.inputValues.flt_no;
                            item.ticket_amount = this.state.inputValues.ticket_amount;
                            item.taxable_value = this.state.inputValues.taxable_value;
                            item.igst = this.state.inputValues.igst;
                            item.total_amount_with_tax = this.state.inputValues.total_amount_with_tax;
                            item.cr_by = 100;
                            item.dep = this.state.inputValues.dep;
                            item.arr = this.state.inputValues.arr;
                            item.from_short_city_name = this.state.inputValues.from_short_city_name;
                            item.to_short_city_name = this.state.inputValues.to_short_city_name;
                            item.airline_names = this.state.inputValues.airline_names;
                            item.party_id = this.state.inputValues.party_id;
                            item.seat_no = this.state.inputValues.seat_no;
                            item.air_fare = this.state.inputValues.air_fare;
                            item.taxes_and_fees = this.state.inputValues.taxes_and_fees;
                        }
                    });
                }
                this.setState({ ticketBookDetails: this.state.ticketBookDetails, serialNo: this.state.serialNo + 1 })
                if (result === 1) {
                    let newJob = {
                        srno: this.state.serialNo,
                        bill_to: this.state.inputValues.bill_to,
                        booked_by: this.state.inputValues.booked_by,
                        invoice_no: this.state.inputValues.invoice_no,
                        invoice_date: new Date().toLocaleDateString('en-CA'),
                        party_gst_no: this.state.inputValues.party_gst_no,
                        place_of_supply: this.state.inputValues.place_of_supply,
                        gmail_id: this.state.inputValues.gmail_id,
                        sac_code: this.state.inputValues.sac_code,
                        date_of_travel: this.state.inputValues.date_of_travel,
                        ticket_no: this.state.inputValues.ticket_no,
                        passenger_name: this.state.inputValues.passenger_name,
                        passenger_name: this.state.inputValues.passenger_name,
                        sector: this.state.inputValues.sector,
                        class: this.state.inputValues.class,
                        flt_no: this.state.inputValues.flt_no,
                        ticket_amount: this.state.inputValues.ticket_amount,
                        taxable_value: this.state.inputValues.taxable_value,
                        igst: this.state.inputValues.igst,
                        total_amount_with_tax: this.state.inputValues.total_amount_with_tax,
                        cr_by: 100,
                        dep: this.state.inputValues.dep,
                        arr: this.state.inputValues.arr,
                        from_short_city_name: this.state.inputValues.from_short_city_name,
                        to_short_city_name: this.state.inputValues.to_short_city_name,
                        airline_names: this.state.inputValues.airline_names,
                        air_fare: this.state.inputValues.air_fare,
                        taxes_and_fees: this.state.inputValues.taxes_and_fees,
                    }
                    this.setState({ inputValues: newJob })
                }

                else if (result === 0) {
                    let newJob = {
                        srno: this.state.serialNo,
                        bill_to: "",
                        booked_by: "",
                        invoice_no: "",
                        invoice_date: new Date().toLocaleDateString('en-CA'),
                        party_gst_no: "",
                        place_of_supply: "",
                        gmail_id: "",
                        sac_code: "",
                        date_of_travel: "",
                        ticket_no: "",
                        passenger_name: "",
                        sector: "",
                        class: "",
                        flt_no: "",
                        ticket_amount: "",
                        taxable_value: "",
                        igst: "",
                        total_amount_with_tax: "",
                        cr_by: 100,
                        dep: "",
                        arr: "",
                        from_short_city_name: "",
                        to_short_city_name: "",
                        airline_names: "",
                        air_fare: "",
                        taxes_and_fees: ""                      
                    }
                    this.setState({ inputValues: newJob })
                }
            }
        });
    }
    handleDataSave = () => {
        if (this.state.inputValues.bill_to === "" || this.state.inputValues.booked_by === "" || this.state.inputValues.party_gst_no === "" || this.state.inputValues.place_of_supply === ""
            || this.state.inputValues.gmail_id === "" || this.state.inputValues.sac_code === ""
            || this.state.inputValues.date_of_travel === "" || this.state.inputValues.ticket_no === ""
            || this.state.inputValues.passenger_name === "" || this.state.inputValues.sector === "" || this.state.inputValues.class === "" || this.state.inputValues.flt_no === ""
            || this.state.inputValues.ticket_amount === "" || this.state.inputValues.taxable_value === "" || this.state.inputValues.total_amount_with_tax === ""
            || this.state.inputValues.dep === "" || this.state.inputValues.arr === "" || this.state.inputValues.from_short_city_name === ""
            || this.state.inputValues.to_short_city_name === "" || this.state.inputValues.airline_names === "" || this.state.inputValues.seat_no === ""
            || this.state.inputValues.air_fare === "" || this.state.inputValues.taxes_and_fees === "") {
            toast.error("Please fill in all input fields.")
            if (this.state.inputValues.bill_to === "") document.querySelector("#bill_to").style.border = "1px solid red";
            if (this.state.inputValues.booked_by === "") document.querySelector("#booked_by").style.border = "1px solid red";
            if (this.state.inputValues.place_of_supply === "") document.querySelector("#place_of_supply").style.border = "1px solid red";
            if (this.state.inputValues.gmail_id === "") document.querySelector("#gmail_id").style.border = "1px solid red";
            if (this.state.inputValues.sac_code === "") document.querySelector("#sac_code").style.border = "1px solid red";
            if (this.state.inputValues.date_of_travel === "") document.querySelector("#date_of_travel").style.border = "1px solid red";
            if (this.state.inputValues.passenger_name === "") document.querySelector("#passenger_name").style.border = "1px solid red";
            if (this.state.inputValues.ticket_no === "") document.querySelector("#ticket_no").style.border = "1px solid red";
            if (this.state.inputValues.passenger_name === "") document.querySelector("#passenger_name").style.border = "1px solid red";
            if (this.state.inputValues.sector === "") document.querySelector("#sector").style.border = "1px solid red";
            if (this.state.inputValues.class === "") document.querySelector("#class").style.border = "1px solid red";
            if (this.state.inputValues.flt_no === "") document.querySelector("#flt_no").style.border = "1px solid red";
            if (this.state.inputValues.ticket_amount === "") document.querySelector("#ticket_amount").style.border = "1px solid red";
            if (this.state.inputValues.taxable_value === "") document.querySelector("#taxable_value").style.border = "1px solid red";
            if (this.state.inputValues.dep === "") document.querySelector("#dep").style.border = "1px solid red";
            if (this.state.inputValues.arr === "") document.querySelector("#arr").style.border = "1px solid red";
            if (this.state.inputValues.from_short_city_name === "") document.querySelector("#from_short_city_name").style.border = "1px solid red";
            if (this.state.inputValues.seat_no === "") document.querySelector("#seat_no").style.border = "1px solid red";
            if (this.state.inputValues.to_short_city_name === "") document.querySelector("#to_short_city_name").style.border = "1px solid red";
            if (this.state.inputValues.airline_names === "") document.querySelector("#airline_names").style.border = "1px solid red";
            if (this.state.inputValues.air_fare === "") document.querySelector("#air_fare").style.border = "1px solid red";
            if (this.state.inputValues.taxes_and_fees === "") document.querySelector("#taxes_and_fees").style.border = "1px solid red";


            if (this.state.inputValues.bill_to !== "") document.querySelector("#bill_to").style.border = "";
            if (this.state.inputValues.booked_by !== "") document.querySelector("#booked_by").style.border = "";
            if (this.state.inputValues.place_of_supply !== "") document.querySelector("#place_of_supply").style.border = "";
            if (this.state.inputValues.gmail_id !== "") document.querySelector("#gmail_id").style.border = "";
            if (this.state.inputValues.sac_code !== "") document.querySelector("#sac_code").style.border = "";
            if (this.state.inputValues.date_of_travel !== "") document.querySelector("#date_of_travel").style.border = "";
            if (this.state.inputValues.passenger_name !== "") document.querySelector("#passenger_name").style.border = "";
            if (this.state.inputValues.ticket_no !== "") document.querySelector("#ticket_no").style.border = "";
            if (this.state.inputValues.passenger_name !== "") document.querySelector("#passenger_name").style.border = "";
            if (this.state.inputValues.sector !== "") document.querySelector("#sector").style.border = "";
            if (this.state.inputValues.class !== "") document.querySelector("#class").style.border = "";
            if (this.state.inputValues.flt_no !== "") document.querySelector("#flt_no").style.border = "";
            if (this.state.inputValues.ticket_amount !== "") document.querySelector("#ticket_amount").style.border = "";
            if (this.state.inputValues.taxable_value !== "") document.querySelector("#taxable_value").style.border = "";
            if (this.state.inputValues.dep !== "") document.querySelector("#dep").style.border = "";
            if (this.state.inputValues.arr !== "") document.querySelector("#arr").style.border = "";
            if (this.state.inputValues.from_short_city_name !== "") document.querySelector("#from_short_city_name").style.border = "";
            if (this.state.inputValues.seat_no !== "") document.querySelector("#seat_no").style.border = "";
            if (this.state.inputValues.to_short_city_name !== "") document.querySelector("#to_short_city_name").style.border = "";
            if (this.state.inputValues.airline_names !== "") document.querySelector("#airline_names").style.border = "";
            if (this.state.inputValues.air_fare !== "") document.querySelector("#air_fare").style.border = "";
            if (this.state.inputValues.taxes_and_fees !== "") document.querySelector("#taxes_and_fees").style.border = "";
            return false;
        }

        if (this.state.inputValues.gmail_id !== "") {
            var inputvalues = this.state.inputValues.gmail_id
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if (!regex.test(inputvalues)) {
                toast.error('Invalid Email ID Enter!')
                return false;
            }
        }

        if (this.state.inputValues.isUpdated === undefined) {
            this.state.ticketBookDetails.push(this.state.inputValues)
        }
        else {
            let updatedSrno = 1;
            this.state.ticketBookDetails.forEach(item => {
                if (item.isUpdated && item.srno == this.state.inputValues.srno) {
                    item.srno = this.state.inputValues.srno;
                    item.bill_to = this.state.inputValues.bill_to;
                    item.booked_by = this.state.inputValues.booked_by;
                    item.invoice_no = this.state.inputValues.invoice_no;
                    item.invoice_date = this.state.inputValues.invoice_date;
                    item.party_gst_no = this.state.inputValues.party_gst_no;
                    item.place_of_supply = this.state.inputValues.place_of_supply;
                    item.gmail_id = this.state.inputValues.gmail_id;
                    item.sac_code = this.state.inputValues.sac_code;
                    item.date_of_travel = this.state.inputValues.date_of_travel;
                    item.ticket_no = this.state.inputValues.ticket_no;
                    item.passenger_name = this.state.inputValues.passenger_name;
                    item.sector = this.state.inputValues.sector;
                    item.class = this.state.inputValues.class;
                    item.flt_no = this.state.inputValues.flt_no;
                    item.ticket_amount = this.state.inputValues.ticket_amount;
                    item.taxable_value = this.state.inputValues.taxable_value;
                    item.igst = this.state.inputValues.igst;
                    item.total_amount_with_tax = this.state.inputValues.total_amount_with_tax;
                    item.cr_by = 100;
                    item.dep = this.state.inputValues.dep;
                    item.arr = this.state.inputValues.arr;
                    item.from_short_city_name = this.state.inputValues.from_short_city_name;
                    item.to_short_city_name = this.state.inputValues.to_short_city_name;
                    item.airline_names = this.state.inputValues.airline_names;
                    item.party_id = this.state.inputValues.party_id;
                    item.seat_no = this.state.inputValues.seat_no;
                    item.seat_no = this.state.inputValues.air_fare;
                    item.seat_no = this.state.inputValues.taxes_and_fees;
                    item.seat_no = this.state.inputValues.total_air_fare;
                }
            });
        }

        this.setState({
            ticketBookDetails: this.state.ticketBookDetails,
            inputValues: {
                srno: 1,
                bill_to: "",
                booked_by: "",
                invoice_no: "",
                invoice_date: new Date().toLocaleDateString('en-CA'),
                party_gst_no: "",
                place_of_supply: "",
                gmail_id: "",
                sac_code: "",
                date_of_travel: "",
                ticket_no: "",
                passenger_name: "",
                sector: "",
                class: "",
                flt_no: "",
                ticket_amount: "",
                taxable_value: "",
                cgst: "",
                sgst: "",
                igst: "",
                total_amount_with_tax: "",
                cr_by: 100,
                dep: "",
                arr: "",
                from_short_city_name: "",
                to_short_city_name: "",
                airline_names: "",
                party_id: "",
                seat_no: "",
                air_fare: "",
                taxes_and_fees: "",
                total_air_fare: "",
            }
        })

        Swal.fire({
            icon: "success",
            title: "Your data has been saved in the table below.",
            showConfirmButton: false,
            timer: 1500
        });

    }





    handledit = (cell, e) => {
        debugger
        window.scrollTo({
            top: 0,
            behavior: "smooth" // This smooths the scroll animation
        });

        cell.isUpdated = true;
        this.setState({ inputValues: cell })
    }

    handleDeleteRecord = (cell) => {
        var TicketData = []

        var selectedRow = {
            Srno: cell.srno,
            id: cell.id,

            del_by: this.state.userId,
            isUpdated: true
        }
        TicketData.push(selectedRow)

        let masterData = {
            data: TicketData
        }

        Swal.fire({
            title: 'Are you sure you want to delete?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DB4444',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
        }).then((result) => {
            if (result.isConfirmed) {
                const options = this.state.ticketBookDetails.filter((item) => {
                    return item.srno !== cell.srno
                })


                this.setState({ ticketBookDetails: options })
                Swal.fire(
                    'Deleted!',
                    'Your Data has been Deleted.',
                    'success'
                )

            } else {

            }
        }).catch((error) => {
            // Handle error
        });
    }

    handleSaveBookeTicket = () => {
        debugger
        var ticketData = this.state.ticketBookDetails;
        ticketData = { data: ticketData }

        if (this.state.ticketBookDetails.length > 0) {
            this.setState({ loading: true })
            axios.post(`/saveTicketDetail`, ticketData).then((res) => {
                if (res.data.success == "success") {
                    this.setState({ loading: false })

                }
            })
            this.setState({
                ticketBookDetails: [],
                inputValues: {
                    srno: 1,
                    bill_to: "",
                    booked_by: "",
                    invoice_no: "",
                    invoice_date: "",
                    party_gst_no: "",
                    place_of_supply: "",
                    gmail_id: "",
                    sac_code: "",
                    date_of_travel: "",
                    ticket_no: "",
                    passenger_name: "",
                    sector: "",
                    class: "",
                    flt_no: "",
                    ticket_amount: "",
                    taxable_value: "",
                    cgst: "",
                    sgst: "",
                    igst: "",
                    total_amount_with_tax: "",
                    cr_by: "",
                    dep: "",
                    arr: "",
                    from_short_city_name: "",
                    to_short_city_name: "",
                    airline_names: "",
                    party_id: "",
                    seat_no: "",
                    air_fare: "",
                    taxes_and_fees: "",
                    total_air_fare: "",

                }
            })
            Swal.fire({
                icon: "success",
                title: "Your data has been saved in below table",
                showConfirmButton: false,
                timer: 2000
            });
        }
        else {
            this.setState({ loading: false })
            Swal.fire({
                icon: "error",
                title: "No any ticket details present in above table",
                showConfirmButton: false,
                timer: 2000
            });
        }
        this.getInvoiceNo()
    }

    render() {
        const { inputValues, merchandiseTotal } = this.state;
        const totalSum = ""

        var ticketAmountSum = 0;
        var taxableValueSum = 0;
        var igstSum = 0;
        var totalAmountWithTaxSum = 0;
        this.state.ticketBookDetails.forEach(ticket => {
            ticketAmountSum += parseFloat(ticket.ticket_amount);
            taxableValueSum += parseFloat(ticket.taxable_value);
            igstSum += parseFloat(ticket.igst);
            totalAmountWithTaxSum += parseFloat(ticket.total_amount_with_tax);
        });

        return (
            <>
                {this.state.loading ? <Loader /> :
                    <div className="container-fluid">
                        <div className="row mt-2">
                            <div className="col-md-2">
                                <SideBar ScreenName={"Ticket Booking Details"} />
                            </div>
                            <div className="col-md-10">
                                <div className="container h-100 poDetailsContainer_media" style={{ marginTop: "73px", backgroundColor: "#f9fbfd", width: "96%", marginLeft: "34px" }}>
                                    <div className="row m-0 p-0 align-items-center justify-content-center mb-3">
                                        <div className="col-md-8 mt-3">
                                            <h4 className='FontB'><b>INVOICE NO. {this.state.inputValues.invoice_no || ""}</b></h4>
                                        </div>
                                        <div className="col-md-4 mt-2 m-0 p-0 text-end mt-3">
                                            <button onClick={() => this.HandleAddNewRow()} className="btn-sm  buttonBorder me-2" style={{ cursor: "pointer" }}>Add Ticket</button>

                                            {/* </div>
                                    <div className="col-md-2  mt-3"> */}
                                            <button type="submit" onClick={() => this.handleDataSave()} className="btn-sm buttonBorder2G" style={{ cursor: "pointer", color: 'white' }}>Save Changes</button>

                                        </div>

                                    </div>
                                    <form id="myform1">
                                        <div className="row">
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Date of Travel  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="date" id='date_of_travel'
                                                    className="form-control"
                                                    value={inputValues.date_of_travel}
                                                    name="date_of_travel"
                                                    onChange={this.handleInputChange}
                                                    required
                                                />

                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Ticket Number  <span style={{ color: 'red' }}>*</span></label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.ticket_no}
                                                    name="ticket_no" id='ticket_no'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />

                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Seat Number<span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.seat_no}
                                                    name="seat_no" id='seat_no'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Passenger Name  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.passenger_name}
                                                    name="passenger_name" id='passenger_name'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />

                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Passenger Email Id  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    value={inputValues.gmail_id}
                                                    name="gmail_id" id='gmail_id'
                                                    onChange={this.handleInputChange}
                                                    required
                                                    pattern="[a-zA-Z0-9._%+-]+@gmail.com" // Regular expression pattern for Gmail address
                                                />
                                                <div className="invalid-feedback">Please enter a valid Gmail email address.</div>

                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Sector  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.sector}
                                                    name="sector" id='sector'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />

                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Class  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.class}
                                                    name="class" id='class'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Flt. No  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.flt_no}
                                                    name="flt_no" id='flt_no'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />

                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Hs/Sac Code  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.sac_code}
                                                    name="sac_code" id='sac_code'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Departure  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    value={inputValues.dep}
                                                    name="dep" id='dep'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />

                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Arrival <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    value={inputValues.arr}
                                                    name="arr" id='arr'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">From <span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    value={inputValues.from_city_name} name="from_city_name" id='from_short_city_name'
                                                    className="common-input form-select form-control"
                                                    onChange={(e) => { this.handleCityChange(e, "from_short_city_name", "from_full_city_name") }}

                                                >
                                                    <option value="">Select</option>
                                                    {this.state.CityMasterData.map((item) => (
                                                        <option value={item.id}>{item.city_name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">To <span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    value={inputValues.to__city_name} name="to_city_name" id='to_short_city_name'
                                                    className="common-input form-select form-control"
                                                    onChange={(e) => { this.handleCityChange(e, "to_short_city_name", "to_full_city_name") }}
                                                >
                                                    <option value="">Select</option>
                                                    {this.state.CityMasterData.map((item) => (
                                                        <option value={item.id}>{item.city_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Airline Name <span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    value={inputValues.airline_names} name="airline_names" id='airline_names'
                                                    className="common-input form-select form-control"
                                                    onChange={this.handleInputChange}
                                                >
                                                    <option value="">Select</option>
                                                    {this.state.AirlineMasterData.map((item) => (
                                                        <option value={item.name}>{item.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Ticket Amount  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={inputValues.ticket_amount}
                                                    name="ticket_amount" id='ticket_amount'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />

                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Taxable Value</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={inputValues.taxable_value}
                                                    name="taxable_value" id='taxable_value'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />
                                            </div>


                                        </div>

                                        <div className="row">
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">CGST</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.cgst}
                                                    name="cgst"
                                                    onChange={this.handleInputChange}
                                                    required
                                                    readOnly
                                                    disabled
                                                />
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">SGST</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.sgst}
                                                    name="sgst"
                                                    onChange={this.handleInputChange}
                                                    required
                                                    readOnly
                                                    disabled
                                                />

                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">IGST</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.igst}
                                                    name="igst"
                                                    onChange={this.handleInputChange}
                                                    required
                                                    readOnly
                                                    disabled
                                                />
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Total</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.total_amount_with_tax}
                                                    name="total_amount_with_tax"
                                                    onChange={this.handleInputChange}
                                                    required
                                                    readOnly
                                                    disabled
                                                />
                                            </div>

                                        </div>

                                        <div className="row">
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Air Fare  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={inputValues.air_fare}
                                                    name="air_fare" id='air_fare'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />

                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Taxes & Fees  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={inputValues.taxes_and_fees}
                                                    name="taxes_and_fees" id='taxes_and_fees'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />

                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Total Air Fare </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={inputValues.cal_total_air_fare}
                                                    name="cal_total_air_fare" id='cal_total_air_fare'
                                                    onChange={this.handleInputChange}
                                                    required
                                                    readOnly
                                                    disabled
                                                />

                                            </div>
  
                                        </div>

                                        <hr></hr>
                                        <div className="row">
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Invoice No.</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.invoice_no}
                                                    name="invoice_no"
                                                    onChange={this.handleInputChange}
                                                    required
                                                    readOnly disabled
                                                />



                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Invoice Date </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={inputValues.invoice_date}
                                                    name="invoice_date"
                                                    onChange={this.handleInputChange}
                                                    required
                                                    readOnly
                                                    disabled
                                                />
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Place of Supply  <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.place_of_supply}
                                                    name="place_of_supply" id='place_of_supply'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <hr></hr>
                                        <div className="row">
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Booked By  <span style={{ color: 'red' }}>*</span></label>
                                                <textarea
                                                    type="text"
                                                    style={{ height: "90px", resize: "none" }}
                                                    className="form-control"
                                                    value={inputValues.booked_by}
                                                    name="booked_by" id='booked_by'
                                                    onChange={this.handleInputChange}
                                                    required
                                                />
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Bill to<span style={{ color: 'red' }}>*</span></label>
                                                <select id='bill_to'
                                                    value={inputValues.party_id} name="party_id"
                                                    className="common-input form-select form-control"
                                                    onChange={this.handlePartyChange}
                                                >
                                                    <option value="">Select</option>
                                                    {this.state.PartyMasterData.map((item) => (
                                                        <option value={item.party_id}>{item.party_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-3 mt-2">
                                                <label className="form-label">Party GST No. </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={inputValues.party_gst_no}
                                                    name="party_gst_no"
                                                    onChange={this.handleInputChange}
                                                    required
                                                    readOnly
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        <hr></hr>

                                    </form>
                                    {/* <hr style={{ marginTop: "72px" }} /> */}
                                    <div class="table-responsive">
                                        <div className='row mb-3'>
                                            <div className='col-md-12'>
                                                <button className="btn-primary1 p-2" style={{ border: "1px solid burlywood" }} >Ticket Details</button>
                                            </div>
                                        </div>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th className='thBg' scope="col" rowSpan={2} style={{ minWidth: "100px", textAlign: "center" }}>Edit / Delete </th>
                                                    <th className='thBg' scope="col" rowSpan={2} style={{ minWidth: "100px", textAlign: "center" }}>Hs/Sac Code</th>
                                                    <th className='thBg' scope="col" rowSpan={2} style={{ minWidth: "300px", textAlign: "center" }}>Description<p>Date of Travel &nbsp; &nbsp; &nbsp;   Ticket    Number</p></th>
                                                    <th className='thBg' scope="col" rowSpan={2} style={{ minWidth: "100px", textAlign: "center" }}>Ticket Amount</th>
                                                    <th className='thBg' scope="col" rowSpan={2} style={{ minWidth: "150px", textAlign: "center" }}>Taxable Value</th>
                                                    <th className='thBg' scope="col" colSpan={2} style={{ minWidth: "100px", textAlign: "center" }}>CGST </th>
                                                    <th className='thBg' scope="col" colSpan={2} style={{ minWidth: "150px", textAlign: "center" }}>SGST</th>
                                                    <th className='thBg' scope="col" colSpan={2} style={{ minWidth: "150px", textAlign: "center" }}>IGST </th>
                                                    <th className='thBg' scope="col" rowSpan={2} style={{ minWidth: "150px", textAlign: "center" }}>Total </th>

                                                </tr>
                                                <tr>
                                                    <th className='thBg' scope="col" style={{ textAlign: "center" }}>% </th>
                                                    <th className='thBg' scope="col" style={{ textAlign: "center" }}>Amount</th>
                                                    <th className='thBg' scope="col" style={{ textAlign: "center" }}>% </th>
                                                    <th className='thBg' scope="col" style={{ textAlign: "center" }}>Amount</th>
                                                    <th className='thBg' scope="col" style={{ textAlign: "center" }}>% </th>
                                                    <th className='thBg' scope="col" style={{ textAlign: "center" }}>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.ticketBookDetails.map((item, index) => (
                                                    <tr key={item.line_id}>
                                                        <td>
                                                            <FontAwesomeIcon
                                                                icon={faEdit}
                                                                onClick={(e) => this.handledit(item, index, e)}
                                                                style={{ color: "#227446", fontSize: "18px", borderRight: '1px solid black', paddingRight: '9px', cursor: 'pointer' }}
                                                            />
                                                            <FontAwesomeIcon
                                                                icon={faTrash}
                                                                onClick={(e) => this.handleDeleteRecord(item, index, e)}
                                                                style={{ cursor: 'pointer', color: "red", fontSize: "18px", marginLeft: '10px' }}
                                                            />
                                                        </td>                                                <td>{item.sac_code}</td>
                                                        <td>{item.date_of_travel + " " + " " + item.ticket_no}<p><b>Passenger Name</b>{item.passenger_name}</p>
                                                            <p><b>Sector :</b>{item.sector + "   "} <span><b>Class :</b>{"   " + item.class}</span></p>
                                                            <p><b>Flt No. :</b>{item.flt_no}</p>
                                                        </td>
                                                        <td> {item.ticket_amount}</td>
                                                        <td> {item.taxable_value}</td>
                                                        <td> 9.00</td>
                                                        <td> {item.cgst}</td>
                                                        <td> 9.00</td>

                                                        <td> {item.sgst}</td>
                                                        <td> 18</td>
                                                        <td> {item.igst}</td>
                                                        <td> {item.total_amount_with_tax}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot className='Font'>
                                                <tr>
                                                    <td colSpan="3" style={{ textAlign: "right" }}> Total : </td>
                                                    <td>{ticketAmountSum}</td> {/* Display merchandiseTotal */}
                                                    <td>{taxableValueSum}</td>
                                                    <td></td> {/* Display totalSum */}
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{igstSum}</td>
                                                    <td>{totalAmountWithTaxSum}</td>

                                                </tr>
                                                <tr>
                                                    <td colSpan="11" style={{ textAlign: "right" }}> Total GST:</td>
                                                    <td>{igstSum}</td>

                                                </tr>
                                                <tr>
                                                    <td colSpan="11"> Payment Mode : CREDIT <p style={{ textAlign: "right" }}>ROUND OFF :</p></td>
                                                    <td></td>

                                                </tr>
                                                <tr>
                                                    <td colSpan="11" style={{ textAlign: "right" }}> Nett Bill Amount :</td>
                                                    <td>{totalAmountWithTaxSum}</td>

                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div className="col-md-12 mt-2 m-0 p-0 text-end mt-3">

                                        <button type="submit" onClick={() => this.handleSaveBookeTicket()} className="btn-sm buttonBorder2G" style={{ cursor: "pointer", color: 'white' }}>Booked Ticket</button>

                                    </div>
                                    <hr />
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}

